'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

import LoaderSvc from './loader.service.js';
import loadTemplate from './loader.pug';

export default angular.module('directives.loader', [])
  .directive('loader', function() {
    return {
      template: loadTemplate
    };
  })
  .factory('LoaderSvc', LoaderSvc)
  .name;
